<header class="w3-container" style="padding-top:22px">
  
    <table style="width: 100%"><tr>
      <td style="width:100%"><h5><b><i class="fa fa-book"></i> {{exam}} - {{title}}</b></h5></td>
      <td><button (click)="setLang('C')" mat-button class="w3-theme-d1" >中</button></td>
	    <td><button (click)="setLang('E')" mat-button class="w3-theme-d1" >EN</button></td>	
      </tr>
      </table>
      
    </header> 
  
    <div class="w3-panel">
      <div class="w3-row-padding" style="margin:0 -16px">
          <div class="w3-container" >
 
      </div>
      

      <div *ngFor="let question of questions  | async ; index as question_no" class=" w3-section">
            <mat-card>    
                    <h5>Question {{question_no +1}}<span style="font-size: 12px"> - {{question.paper_name}}   Q{{question.question_no}} </span></h5>

          <div style="max-width: 700px;" class=" w3-container w3-middle">
            <!-- Old naming method-->
            <span *ngIf="question.paper_id >= 11 && question.paper_id < 35">
              <p><img style="max-width: 100%;max-height: 800px;"  src="https://res.cloudinary.com/dw6hcpiyd/image/upload/v1580972158/bio/{{question.folder_name}}_Q{{question.question_no}}_{{lang}}.png"></p>
            </span>
            <!-- New naming method-->
            <span *ngIf="question.paper_id < 11 || question.paper_id >= 35">
              <p><img style="max-width: 100%;max-height: 800px;"  src="https://res.cloudinary.com/dw6hcpiyd/image/upload/v1580972158/bio/{{question.folder_name}}/{{question.folder_name}}_Q{{question.question_no}}_Q__{{lang}}.png"></p>
            </span>
            </div>
            <table style="width: 100%"><tr>
                <td><button disabled mat-button class="w3-theme-l3 w3-block "><i class="fa fa-youtube-play"></i></button></td>
            <td style="width: 100%"><button (click)="openAnswerDialog(question,lang)"  mat-button class="w3-theme-l3 w3-block "><i class="fa fa-file-picture-o"></i> Solution + Report</button></td>
          
            
            <td><button disabled mat-button (click)="openDialog()" class="w3-theme-l3 w3-block "><i class="fa fa-comment"></i></button></td>
            </tr>
            </table>
        </mat-card>
        
      </div>
  